import { createAction, handleActions } from "redux-actions";
import { createRoutine } from "redux-saga-routines";

export const paymentDetailsRoutine = createRoutine(
  "app/payment/PAYMENT_DETAILS"
);

export const updateCreditCardRoutine = createRoutine(
  "app/payment/UPDATE_CREDIT_CARD"
);

export const finalizePaymentRoutine = createRoutine(
  "app/payment/FINALIZE_PAYMENT"
);

export const finalizePaymentNativeRoutine = createRoutine(
  "app/payment/FINALIZE_PAYMENT_NATIVE"
);

export const releasePaymentRoutine = createRoutine(
  "app/payment/RELEASE_PAYMENT"
);

export const handlePaymentAfterRedirectRoutine = createRoutine(
  "app/payment/HANDLE_PAYMENT_AFTER_REDIRECT"
);

export const fetchCurrentOfferRoutine = createRoutine(
  "app/payment/FETCH_CURRENT_OFFER"
);
export const fetchSelectedOfferRoutine = createRoutine(
  "app/payment/FETCH_SELECTED_OFFER"
);

export const CLEAR_PAYMENT_DETAILS = "app/payment/CLEAR_PAYMENT_DETAILS";
export const clearPaymentDetails = createAction(CLEAR_PAYMENT_DETAILS);

export const initialState = {
  loading: true,
  error: null,
  data: {},
  paymentFormLoading: false,
  currentOfferLoading: false,
  currentOffer: null,
  selectedOfferLoading: null,
  selectedOffer: null,
  selectedOfferError: null
};

export default handleActions(
  {
    [paymentDetailsRoutine.TRIGGER]: state => state,
    [paymentDetailsRoutine.REQUEST]: state => ({
      ...state,
      loading: true,
      error: null
    }),
    [paymentDetailsRoutine.SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      error: null,
      data: action.payload
    }),
    [paymentDetailsRoutine.FAILURE]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload
    }),
    [paymentDetailsRoutine.FULFILL]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload
    }),
    [CLEAR_PAYMENT_DETAILS]: () => initialState,
    [finalizePaymentRoutine.TRIGGER]: state => ({
      ...state,
      paymentFormLoading: true
    }),
    [finalizePaymentRoutine.SUCCESS]: state => ({
      ...state,
      paymentFormLoading: false
    }),
    [finalizePaymentRoutine.FAILURE]: state => ({
      ...state,
      paymentFormLoading: false
    }),
    [finalizePaymentNativeRoutine.TRIGGER]: state => ({
      ...state,
      paymentFormLoading: true
    }),
    [finalizePaymentNativeRoutine.SUCCESS]: state => ({
      ...state,
      paymentFormLoading: false
    }),
    [finalizePaymentNativeRoutine.FAILURE]: state => ({
      ...state,
      paymentFormLoading: false
    }),
    [fetchCurrentOfferRoutine.TRIGGER]: state => ({
      ...state,
      currentOfferLoading: true
    }),
    [fetchCurrentOfferRoutine.FAILURE]: state => ({
      ...state,
      currentOfferLoading: false
    }),
    [fetchCurrentOfferRoutine.SUCCESS]: (state, action) => ({
      ...state,
      currentOfferLoading: false,
      currentOffer: action.payload
    }),
    [fetchSelectedOfferRoutine.TRIGGER]: state => ({
      ...state,
      selectedOfferLoading: true
    }),
    [fetchSelectedOfferRoutine.FAILURE]: state => ({
      ...state,
      selectedOfferLoading: false,
      selectedOfferError: true
    }),
    [fetchSelectedOfferRoutine.SUCCESS]: (state, action) => {
      return {
        ...state,
        selectedOfferLoading: false,
        selectedOfferError: false,
        selectedOffer: action.payload
      };
    }
  },
  initialState
);
